import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class MarketParityParityManagerAddissueRoute extends Route {
  @service access;
  @service transition;

  beforeModel(transition) {
    if (!this.access.can('market.paritymanager.manualissues.add')) {
      this.transition.redirectToTab(transition, 'market.parity.parity-manager');
    }
  }
}
